import { Anchor, Button, Card, Center, Group, PinInput, Stack, Text, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { api } from '../api';
import { apiErrorMessage } from '../api/client';
import { t } from '../dictionary';
import { useAuth } from '../providers/auth-context';

export const VerifyEmailPage = () => {
    const [params] = useSearchParams();
    const email = params.get('email') ?? '';
    const { setPartner } = useAuth();

    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [resending, setResending] = useState(false);

    const submit = async () => {
        if (code.length !== 6) {
            notifications.show({ color: 'red', message: t.auth.codeInvalid });

            return;
        }

        setLoading(true);

        try {
            const { data } = await api.verifyEmail({ email, code });

            // Успех: контекст получает партнёра, роутер сам уводит в кабинет.
            setPartner(data.partner);
        } catch (error) {
            notifications.show({ color: 'red', message: apiErrorMessage(error) });
        } finally {
            setLoading(false);
        }
    };

    const resend = async () => {
        setResending(true);

        try {
            await api.resendCode(email);
            notifications.show({ color: 'green', message: t.auth.resendDone });
        } catch (error) {
            notifications.show({ color: 'red', message: apiErrorMessage(error) });
        } finally {
            setResending(false);
        }
    };

    return (
        <Card padding='xl' shadow='sm'>
            <Stack gap='md'>
                <div>
                    <Title order={2}>{t.auth.verifyTitle}</Title>
                    <Text c='dimmed' size='sm' mt={4}>
                        {t.auth.verifySubtitle(email)}
                    </Text>
                </div>

                <Center>
                    <PinInput
                        length={6}
                        type='number'
                        size='lg'
                        value={code}
                        onChange={setCode}
                        onComplete={submit}
                        oneTimeCode
                        autoFocus
                    />
                </Center>

                <Button fullWidth loading={loading} onClick={submit}>
                    {t.auth.verifyButton}
                </Button>

                <Group justify='space-between'>
                    <Anchor component={Link} to='/login' size='sm'>
                        {t.auth.backToLogin}
                    </Anchor>
                    <Button variant='subtle' size='compact-sm' loading={resending} onClick={resend}>
                        {t.auth.resend}
                    </Button>
                </Group>
            </Stack>
        </Card>
    );
};
